import { chakra, Td, Th } from '@chakra-ui/react';

export const ThStyled = chakra(Th, {
  baseStyle: {
    color: '#667085',
    fontWeight: '400',
    fontSize: '14px',
    textAlign: 'left',
    padding: '8px',
    textTransform: 'unset',
    border: '1px solid #E2E8F0',
  },
});

export const TdStyled = chakra(Td, {
  baseStyle: {
    color: '#667085',
    fontWeight: '400',
    fontSize: '14px',
    textAlign: 'left',
    padding: '8px',
    textTransform: 'unset',
    border: '1px solid #E2E8F0',
  },
});
